'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));

var FLASH_CONTAINER_SELECTOR = '.flash-container';

function Flash() {
  this.$containers = $(FLASH_CONTAINER_SELECTOR);

  if (this.$containers.length) {
    $(document).on('click', '.js-close-flash', this.close.bind(this));
  }
}

Flash.prototype.close = function (evt) {
  var $container = $(evt.target).closest(FLASH_CONTAINER_SELECTOR);
  var removalTargetID = $container.data('removalTargetId');

  if (removalTargetID) {
    $('#' + removalTargetID).remove();
  } else {
    $container.remove();
  }
};

module.exports = Flash;
